import React from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import styles from "../assets/styles/offers.module.css";
import { offersList } from "../utils/functions/offersData";

const OfferDetails: React.FC = () => {
    const { id } = useParams();
    const navigate = useNavigate()
    const offer = offersList.find((o) => o.id === Number(id));

    if (!offer) {
        return (
            <div className="container py-10">
                <h2>Offer not found</h2>
                <Link to="/offers" className="text-blue-500 underline">
                    Back to Offers
                </Link>
            </div>
        );
    }

    const copyCode = () => {
        if (offer.code) {
            navigator.clipboard.writeText(offer.code);
            alert("Code copied: " + offer.code);
        }
    };

    return (
        <div className="container py-10">
            <div className={styles.offersCardMain}>
                <div className={styles.offersCardContent}>
                    <h2 className="text-2xl font-bold mb-4">{offer.title}</h2>
                    <p className="text-gray-600 mb-2">
                        <strong>Valid till:</strong> {offer.validTill}
                    </p>

                    {offer.code && (
                        <div className="flex items-center gap-4 mb-6">
                            <h3 className="font-semibold">Code: {offer.code}</h3>
                            <button
                                onClick={copyCode}
                                className="fillButton"
                            >
                                Copy
                            </button>
                        </div>
                    )}

                    <h3 className="text-xl font-semibold mb-4">{offer.mainTitle}</h3>

                    <div className="space-y-6">
                        {offer.offers.map((subOffer, idx) => (
                            <div key={idx}>
                                <h4 className="font-semibold mb-2">{subOffer.title}</h4>
                                <ul className="list-disc list-inside space-y-1 text-gray-700">
                                    {subOffer.points.map((point, i) => (
                                        <li key={i}>{point}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>

                    <div className="mt-6">
                        <button
                            onClick={() => navigate("/offers")}
                            className="fillButton"
                        >
                            Back to Offers
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfferDetails;
